import FlexPane from './_flex-pane.js'
import SkeletonPart from './_skeleton-part.js'

export default {
  name: 'EventCardSkeleton',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '18px',
        style: {
          boxSizing: 'border-box',
          width: '294px',
          height: '158px',
          flexDirection: 'column',
          padding: '8px',
          flexGrow: 0,
          flexShrink: 0,
        },
      },
    },
    eventContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    headerContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
          padding: '0 0 16px 0',
        },
      },
    },
    headerTitleSkeleton: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '24px',
          height: '13px',
        },
      },
    },
    participantNameContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
          flexGrow: 0,
        },
      },
    },
    participantNameSkeleton: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '128px',
          height: '14px',
        },
      },
    },
    marketContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '2px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    marketTitleSkeleton: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '40px',
          height: '13px',
        },
      },
    },
    matchSelectionsContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
          justifyContent: 'space-between',
        },
      },
    },
    matchSelectionSkeleton: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '90px',
          height: '44px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
